module.exports = __webpack_public_path__ + "static/media/brackets.c62a77ab.svg";